var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"hover:bg-gray-300 cursor-pointer text-left",on:{"click":_vm.redirectToTarget}},[_c('td',{staticClass:"px-6 py-4"},[_vm._v(" "+_vm._s(_vm.text_template.name)+" ")]),_c('td',{staticClass:"px-6 py-4 text-right"},[_c('font-awesome-icon',{staticClass:"cursor-pointer",attrs:{"icon":['fas', 'chevron-right']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }